import axios from 'axios'

let client = ''

// Import this function to get the client. It didn't want to update when we just used the variable for some reason
const getClient = () => client

const buildClient = () => {
  const token = JSON.parse(localStorage.getItem('Auth-_burry_PurpleWave'))
  if (token) {
    client = axios.create({
      headers: {
        authorization: `bearer ${token.access_token}`,
      },
    })
  } else {
    client = axios.create()
  }
}

buildClient()

export default getClient
export { buildClient }